export default __webpack_public_path__ + "static/media/audio.782ead86.png";